webpackJsonp([177063777667075],{

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SushmaKaushik = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _insights_constants = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(22);
	
	var _reactSpinners = __webpack_require__(21);
	
	var _jquery = __webpack_require__(26);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactPlayer = __webpack_require__(32);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _sendMailIcon = __webpack_require__(30);
	
	var _sendMailIcon2 = _interopRequireDefault(_sendMailIcon);
	
	var _MailForwardForm = __webpack_require__(27);
	
	var _MailForwardForm2 = _interopRequireDefault(_MailForwardForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/sushma.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide,
	      style: { margin: "0% auto 0px" }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SushmaKaushik = exports.SushmaKaushik = function (_React$Component) {
	  _inherits(SushmaKaushik, _React$Component);
	
	  function SushmaKaushik(args) {
	    _classCallCheck(this, SushmaKaushik);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleMailShareForm = function () {
	      _this.setState({ showMailShareForm: !_this.state.showMailShareForm });
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.handleMenu = function (item) {
	      _this.setState({
	        activeTitle: item.title
	      });
	
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      if (item.title === "SORT BY") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else if (item.title === "ALL") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else {
	        [].concat(leftlist).filter(function (insight) {
	          console.log(insight);
	          // a.typee.indexOf(item.title) >= 0}
	          var flag = false;
	          for (var i = 0; i < insight.itype.length; i++) {
	            if (item.title === insight.itype[i]) {
	              flag = true;
	            }
	          }
	          return flag;
	        }).forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      }
	      _this.setState({
	        activeSortBy: item.title
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleSearch = function (e) {
	      var str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      leftlist.forEach(function (item) {
	        if (item.skey.toLowerCase().trim().search(str) > -1) {
	          _this.betterContent.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false,
	      activeKeyword: "",
	      isSearching: false,
	      lastCounter: 3,
	      activeTitle: "SORT BY",
	      activeSortBy: "default",
	      showMailShareForm: false
	    };
	    _this.betterContent = _insights_constants.insightsConstants;
	    _this.TabContent = [
	    // {
	    // 	title: "POPULARITY",
	    // },
	    {
	      title: "ALL"
	    }, {
	      title: "BLOGS"
	    }, {
	      title: "INFOGRAPHICS"
	    }, {
	      title: "INTERVIEWS"
	    }, {
	      title: "VIDEOS"
	    }];
	    _this.Speaker = [{
	      desc: "<div>Sushma is a Partner at Aavishkaar Capital and brings with her over 18 years of diverse experience in the field of early stage investing, small business incubation and consulting across sectors. Sushma has worked to identify, manage and exit large number of companies and has worked closely with several inclusive business entrepreneurs. She has been an active representative on the Boards of several early-growth stage companies. She started off with an entrepreneurial venture in engineering design services and moved on to roles in investments. She was part of the acquisition team at Starwood Capital where she evaluated diverse real estate assets. While at  Ashoka- Innovators for the Public, Sushma got to work with social entrepreneurs in the Housing for All initiative. She has worked closely on building collaborative partnerships in market based solutions for the low-income populations. <br/><br/>\n\n        Sushma has completed a strategic leadership program at the prestigious Harvard Business School. She is an engineering graduate from RVCE, Bangalore and has an MBA from the Indian School of Business, Hyderabad.<br/><br/>\n           \n        Sushma loves solving problems and in her free time mentors startups across diverse fields. She was recognized as \u201C40 UNDER 40\u201D Alternate investment professional in India and as one of the Top 100 Women in Finance-2020 in the \u201Cleading\u201D category.\n        \n        \n        \n        </div>",
	      name: "Sushma Kaushik",
	      post: "Partner, Aavishkaar Capital ",
	      imgUrl: icon1,
	      head: "The Venturous Investor"
	    }];
	    return _this;
	  }
	
	  SushmaKaushik.prototype.componentDidMount = function componentDidMount() {
	    // function sticky_relocate () {
	    // 	var window_top = $(window).scrollTop()
	    // 	var div_top = $("#sticky-anchor").offset().top
	    // 	if (window_top > div_top) {
	    // 		$("#sticky").addClass("stick")
	    // 	} else {
	    // 		$("#sticky").removeClass("stick")
	    // 	}
	    // }
	    // $(function () {
	    // 	$(window).scroll(sticky_relocate)
	    // 	sticky_relocate()
	    // })
	  };
	
	  SushmaKaushik.prototype.render = function render() {
	    var _this2 = this;
	
	    var leftList = this.betterContent.filter(function (item) {
	      return item.url !== "/SushmaKaushik";
	    });
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isSearching = _state.isSearching,
	        isShow = _state.isShow,
	        activeTitle = _state.activeTitle,
	        activeSortBy = _state.activeSortBy;
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_MailForwardForm2.default, {
	        show: this.state.showMailShareForm,
	        onClickClose: this.toggleMailShareForm,
	        url: "insights.php/forward",
	        insight: "The Venturous Investor"
	      }),
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe Insights | The Venturous Investor",
	          image: "https://winpeforum.com/assets/elements/sushma-thumb.jpg",
	          description: "Sushma Kaushik is a well known face of impact investing in India. A risk taker who journeyed through industrial engineering and real estate private equity before finding her long term passion as an impact investor, Sushma talks about her unconventional career path, the evolution of impact investing and building sustainable companies with solid foundations. Read as Sushma busts some common myths on impact investing and shares her advice for young women investors and entrepreneurs.",
	          location: location,
	          keywords: ""
	        }),
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe Insights | The Venturous Investor",
	          image: "https://winpeforum.com/assets/elements/sushma-thumb.jpg",
	          description: "Sushma Kaushik is a well known face of impact investing in India. A risk taker who journeyed through industrial engineering and real estate private equity before finding her long term passion as an impact investor, Sushma talks about her unconventional career path, the evolution of impact investing and building sustainable companies with solid foundations. Read as Sushma busts some common myths on impact investing and shares her advice for young women investors and entrepreneurs.  \r ",
	          location: location,
	          keywords: ""
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "section__content" },
	          _react2.default.createElement(
	            "div",
	            { className: "insights_wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "insights_section" },
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                { query: "(min-width: 768px)" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_main_heading" },
	                  _react2.default.createElement("div", { className: "left_line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights_main_heading_text" },
	                    "Winpe INSIGHTS"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                {
	                  query: "(min-width: 767px)",
	                  style: { display: "none" }
	                },
	                _react2.default.createElement("div", { className: "insights_main_heading" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "insights_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "drop_src_box" },
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { query: "(min-width: 768px)" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_drop_box" },
	                      _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { title: activeTitle },
	                        this.TabContent.map(function (item, j) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                              onClick: function onClick() {
	                                return _this2.handleMenu(item);
	                              },
	                              activeSortBy: activeSortBy,
	                              text: item.title,
	                              key: j
	                            },
	                            item.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    {
	                      query: "(max-width: 767px)",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_drop_box" },
	                      _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { title: activeTitle },
	                        this.TabContent.map(function (item, j) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                              onClick: function onClick() {
	                                return _this2.handleMenu(item);
	                              },
	                              activeSortBy: activeSortBy,
	                              text: item.title,
	                              key: j
	                            },
	                            item.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { query: "(min-width: 768px)" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_scr_box" },
	                      _react2.default.createElement(
	                        "form",
	                        { id: "demo-2" },
	                        _react2.default.createElement("input", {
	                          type: "search",
	                          placeholder: "Search",
	                          onChange: function onChange(e) {
	                            return _this2.handleSearch(e);
	                          },
	                          value: this.state.activeKeyword
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    {
	                      query: "(max-width: 767px)",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement("div", { className: "left_scr_box" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_mid_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      _reactResponsive2.default,
	                      { query: "(min-width: 768px)" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-3 col-md-3" },
	                        _react2.default.createElement("div", { id: "sticky-anchor" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_left_listing" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_left_listing_text" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "left_listing_card left_listing_card--feature" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t1" },
	                                _react2.default.createElement(
	                                  "span",
	                                  null,
	                                  "Interview\xA0"
	                                ),
	                                "\u2022 18 June 2021"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t2" },
	                                "The Venturous Investor"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t3" },
	                                "Sushma Kaushik of Aavishkaar Capital"
	                              )
	                            ),
	                            _react2.default.createElement("div", { className: "left_listing_card--feature__el1" }),
	                            isSearching ? _react2.default.createElement(
	                              "div",
	                              { style: { margin: "10% 25% 10%" } },
	                              _react2.default.createElement(_reactSpinners.ClipLoader, {
	                                color: "#22316B",
	                                loading: isSearching
	                              })
	                            ) : leftList.length ? leftList.slice(0, 27).map(function (item, i) {
	                              return _react2.default.createElement(
	                                "div",
	                                { className: "left_listing_card", key: i },
	                                _react2.default.createElement(
	                                  _gatsbyLink2.default,
	                                  {
	                                    to: "/insights/" + item.url.replace(/[^A-Z0-9]+/gi, "")
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t1" },
	                                    _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      item.type,
	                                      "\xA0"
	                                    ),
	                                    "\u2022 ",
	                                    item.date
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t2" },
	                                    item.ltitle
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t3" },
	                                    item.lname
	                                  )
	                                )
	                              );
	                            }) : _react2.default.createElement(
	                              "div",
	                              { className: "no__product" },
	                              "Not available in the list"
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactResponsive2.default,
	                      {
	                        query: "(max-width: 767px)",
	                        style: { display: "none" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-3 col-md-3" },
	                        _react2.default.createElement("div", { id: "sticky-anchor" }),
	                        _react2.default.createElement("div", { className: "insights_left_listing" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-9 col-md-9" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 2,
	                          animateIn: "slideInRight",
	                          offset: 600
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_right_text" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_blog_page" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "back_event" },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/insights" },
	                                _react2.default.createElement(
	                                  "i",
	                                  { className: "fa fa-arrow-left" },
	                                  " ",
	                                  "browse Insights"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text" },
	                              this.Speaker.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "row" },
	                                  _react2.default.createElement(
	                                    _reactAnimateOnScroll2.default,
	                                    {
	                                      delay: 0,
	                                      duration: 1,
	                                      animateIn: "zoomIn",
	                                      offset: 100
	                                    },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-5 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        {
	                                          className: "right_img_section",
	                                          onClick: function onClick() {
	                                            return _this2.togglePopUp(item);
	                                          }
	                                        },
	                                        _react2.default.createElement("img", {
	                                          src: item.imgUrl,
	                                          alt: "sushma kaushik",
	                                          className: "img-responsive"
	                                        })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-7 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "right_name_section" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_head" },
	                                          item.head
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_name" },
	                                          item.name
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_post" },
	                                          "Partner, Aavishkaar Capital"
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_block" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "INTERVIEW"
	                                          ),
	                                          " \u2022 6 mins read"
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "share_section_one" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "headsocialLink" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                href: "https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: "",
	                                                style: {
	                                                  display: "block !important"
	                                                }
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/SM_icon_01_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://twitter.com/intent/tweet?url=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/SM_icon_02_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                style: {
	                                                  display: "block !important",
	                                                  width: "25px"
	                                                },
	                                                className: "forwardMail",
	                                                title: "Forward to email",
	                                                onClick: _this2.toggleMailShareForm
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: _sendMailIcon2.default,
	                                                alt: ""
	                                              })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text_btm" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "text_section" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "into_text" },
	                                  "Sushma Kaushik is a well known face of impact investing in India. A risk taker who journeyed through industrial engineering and real estate private equity before finding her long term passion as an impact investor, Sushma talks about her unconventional career path, the evolution of impact investing and building sustainable companies with solid foundations. Read as Sushma busts some common myths on impact investing and shares her advice for young women investors and entrepreneurs."
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "interview_vieo_section" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "interview_video" },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "into_text" },
	                                      "\u201CI see impact investing transitioning to v3.0. Now, digitization is becoming an equalizer and technology and innovation are solving for large complex problems like health, education, jobs /livelihood creation etc. and more importantly we are observing very high quality entrepreneurial talent with exceptional technology experience solving for India\u2019s unique problems.\u201D",
	                                      _react2.default.createElement("br", null),
	                                      _react2.default.createElement("br", null)
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q1. You have worked as an entrepreneur, in consulting and in real estate before joining Aavishkaar where you have now spent more than a decade. Please tell us about your journey and how you went about your decisions and career choices."
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "I am an engineering graduate who completed my bachelor\u2019s degree during the period of the famed Dot com bust (2001). And just like most Indian engineering students of that era I graduated with two jobs from campus, but (fortunately) both those got deferred. I could have taken the easy way out like most of my batch-mates did and opt to study abroad, but that wasn\u2019t something that excited me. I realized I had a strong bias for action and so decided to dive head first into entrepreneurship in the Engineering Services for Real Estate Assets. Four years of sourcing business grounds up, handling clients, paying salaries, ensuring cashflows etc. can be the most humbling experience and I would encourage more youngsters to try that out at some point. Entrepreneurship tests the grit and mettle of any individual, and for me it was baptism by fire. 4 years hence, I decided, it was time to explore larger avenues and so sold the business and went on to complete my MBA from ISB Hyderabad (2007). ",
	                                  _react2.default.createElement("br", null),
	                                  _react2.default.createElement("br", null),
	                                  "Because of my Real Estate operating experience in my previous venture, I managed to get one of the few \u201Cbuy side\u201D jobs in a Real Estate PE fund. Back in 2006-2007 there were very few active PE funds in India, so I guess I was lucky to bag a job in one.   ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "Working at Starwood Capital (a global RE PE fund) gave me the experience and rigor required in investing. It also exposed me to working across cross-cultural teams. Those were interesting times when we didn\u2019t have the luxury of rich data bases and had to build investing cases based on ground level research.      ",
	                                  _react2.default.createElement("br", null),
	                                  "Around that time, the start-up ecosystem in India was in its fledgling days and I was keen to work with entrepreneurs again. The VC ecosystem was also evolving and Aavishkaar Capital was one of the most active (micro) VC funds (c USD 32mn) in the Impact space (2010) and I liked what they were building. Impact investing as a theme was emerging and I was keen to participate in that journey and so approached them. As they say, rest is history. ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "Today, the global impact investing market is at USD 715bn. In India alone, impact investing manages assets of >USD 2.7bn. With the awareness in this asset class improving, ESG-focused funds are expected to have over USD 50 trillion of assets by 2025. Currently Aavishkaar Capital manages ~ USD 400mn in AUM with investments across ~60 companies in India and South Asia and is looking to expand further in India and Africa. We are now on our 6th India focussed multi-stage fund targeting a USD 200+mn fund size.     ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "Now when I look back, I realize that I always followed my heart and at the core, I am a risk taker, so I was not afraid of venturing out of my comfort zone to explore uncharted waters. Whether it was pursuing entrepreneurship or RE investing or Impact investing. The other motivating factor for me has been building things grounds up and that\u2019s why start-up investing excites me.",
	                                  _react2.default.createElement("br", null),
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q2. The field of impact investing has seen significant changes and evolution in recent years, with different terms and strategies coming to associate with it. What is your take on impact investing?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Incidentally, the term \u201CImpact Investing\u201D was first coined in 2007, but that doesn\u2019t mean that impact investing didn\u2019t exist before that. In the previous avatar, impact investing was \u201CImpact First\u201D which was seen as an extension of philanthropy. ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "Impact investing v1.0 saw capital supporting entrepreneurs solving for grass root level problems. The challenge in that was \u201Cscale\u201D or rather \u201Clack of scale\u201D. These were businesses that were great local enterprises, creating jobs and livelihoods at local level, but didn\u2019t achieve the right outcomes for investors. ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "Then came Impact Investing v2.0 with the introduction of commercial microfinance institutions. Emergence of this solved a complex social problem of financial inclusion being addressed at a large scale level, yielding great impact and commercial return outcomes for investors. ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "I see impact investing transitioning to v3.0. Now, digitization is becoming an equalizer and technology and innovation are solving for large complex problems like health, education, jobs /livelihood creation etc. and more importantly we are observing very high quality entrepreneurial talent with exceptional technology experience solving for India\u2019s unique problems. This is the main game changer in the impact investing space. Capital flowing into such enterprises is achieving the dual outcome of impact and returns.  ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "The Risk-Return trade-off is specific to Asset Classes, Themes, Stage of investing, type of investing (Buy-out vs. minority) etc. As an asset manager, Returns depend on the fund strategy one has set out to achieve. As a commercial mutli-stage impact investor, Aavishkaar Capitals objective has been to generate commercial returns while focusing on amplifying Impact outcomes. Aavishkaar Capital\u2019s latest fund\u2019s performance is in the top-quartile of funds of that vintage , hence QED!                 ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q3. With responsible investing, ESG reporting and impact measurement becoming increasingly accepted amongst the \u201Ccommercial\u201D funds, lines are blurring. How do impact investors, especially the ones that seek to balance impact with financial rigour, differentiate themselves?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "It\u2019s great to see the evolution of Impact investing from a side-line asset class it was in 2007 to becoming a mainstream asset class today. In-fact this is the much needed shift from the \u201CGreed is Good\u201D model that we are all taught in a capitalistic society, and probably we required a pandemic to recognize the importance of being \u201CResponsible Investors\u201D focussing on sustainability. As investors we need to be conscious of our society and environment while executing on our fiduciary duties. So the first step we are observing in this direction is the approach taken towards measurement of impact with ESG reporting guidelines. ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "However, impact investing requires a deeper level of consciousness of balancing Impact outcomes along with commercial outcomes. This goes beyond just measurement. As impact investors, it is important to set the right foundation in building high quality enterprises that last long. Some of the impact interventions an impact investor is able to bring about become ingrained in the culture of the company early on and is difficult to replicate as a bolt-on strategy later. For example, ensuring diversity and inclusion (D&I) practices at every level (Board, leadership and employment) of an organization takes a generational shift, if incorporated late in the life of a business.  However, if it is incorporated during the formative years of the company, it becomes a way of life.  ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "As businesses grow, the importance of focusing on sustainability in long term value creation is becoming more important. Ignoring the impact of the business on both the environment and the society can be detrimental to any industry. It can cause serious supply chain disruptions, multi-stakeholder problems, customer displeasure, and now investor backlash. Impact investors have an important role to play while partnering with other Investors.    ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q4. Some say gender is the next ESG and some who believe gender and diversity is about impact. Donning the hat of a female partner at an impact investing firm, where do you think gender sits and where do you see it evolving from here?"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Diversity and Inclusion, even beyond gender, should be what we should all try and achieve as a society. One of the Sustainable Development Goals is to achieve an equitable society. At Aavishkaar Group, we have committed to become a Gender Neutral (which goes beyond achieving gender equality) work place by 2030. This is quite an audacious goal to achieve and we have started working in that direction.  ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "In an ideal world, gender shouldn\u2019t even be a topic of discussion and yet it\u2019s the elephant in the room with the multiple cultural biases around this topic. This will continue to be a problem that will take a generational shift to correct, but I am hopeful of seeing change in the right direction as more women come into the work force and become empowered.  ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  "People are always eager to slot things into buckets as that\u2019s how mental models work. Gender equitability could be a measurable impact and so can very well fall under ESG. I believe, it doesn\u2019t matter where it sits, as long as we can achieve the desired outcome.     ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q5. Is gender a focus at Aavishkaar? Please share the efforts that Aavishkaar is making in this area."
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  "Aavishkaar Capital is an equal opportunity employer. 50% of the Investing team are men and they are there only based on merit :) . So while we had not consciously worked on it, that\u2019s how it turned out. The result of having a balanced team, is that we try and neutralize biases. Even investing decisions are taken in a more balanced approach. At Aavishkaar Capital, we have ~60 investments and have created >47,000 jobs and 276,763 livelihoods  and the key beneficiaries are women. As a team we put in efforts to drive change in our portfolio companies to a) build awareness and b) promote gender balance.          ",
	                                  _react2.default.createElement("br", null),
	                                  " ",
	                                  _react2.default.createElement("br", null)
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q6. Busting myths related to impact investing:"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  _react2.default.createElement(
	                                    "ul",
	                                    null,
	                                    " ",
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "Impact investing = no/ low returns "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "Depends on the objective of the impact investor. Commercial impact investors like Aavishkaar Capital strive to achieve commercial outcomes while creating impact."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Women are better impact investors"
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Women tend to be more conscious investors."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Impact is created by small companies, investing in large companies does not create impact "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "Large companies have the advantage of creating a 10x multiplier on impact, provided they are driven with the purpose of impact. Hence, an impact investor has an important role to play as companies scale."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Impact funds are small funds"
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Impact funds need to be present across the continuum of funds, early stage \u2013 growth stage- capital markets \u2013 secondary funds, in-order to preserve impact.",
	                                      _react2.default.createElement("br", null),
	                                      "  ",
	                                      _react2.default.createElement("br", null)
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q7. Advice for young women investors and entrepreneurs, in a single sentence:"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  _react2.default.createElement(
	                                    "ul",
	                                    null,
	                                    " ",
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  Building your brand "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "It\u2019s one of the most important brands worth investing in! "
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "Dealing with being the only woman in the room "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Get used to the attention."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Finding that work-life balance   "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "Prioritize life and balance will fall into place."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Handling being stereotyped or feeling discriminated "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Own that feeling and use it to power forward, also know which battles to fight and when."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Dealing with fund raising biases  "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Things are slowly changing for the better, so keep persevering.  ",
	                                      _react2.default.createElement("br", null),
	                                      "  ",
	                                      _react2.default.createElement("br", null)
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text_Q" },
	                                  "Q8. Tell us more about Sushma:"
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  _react2.default.createElement(
	                                    "ul",
	                                    null,
	                                    " ",
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  Favorite quote/ life motto  "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "When life gives you lemons, enjoy the lemonade!"
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      " ",
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  Leadership mantra  "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Be the change you want to see."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          " Milestone closest to your heart    "
	                                        )
	                                      ),
	                                      _react2.default.createElement("br", null),
	                                      "I am grateful to every milestone that has got me this far\u2026"
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  An unpleasant incident that taught you a valuable lesson  "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "This pandemic has taught me an important lesson- Life is too short, be kind and inspire people, because that\u2019s what people will remember you for!"
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "  What drives you   "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "The quest for a good problem to solve."
	                                    ),
	                                    _react2.default.createElement(
	                                      "li",
	                                      null,
	                                      _react2.default.createElement(
	                                        "b",
	                                        null,
	                                        _react2.default.createElement(
	                                          "i",
	                                          null,
	                                          "   Your stress buster   "
	                                        )
	                                      ),
	                                      " ",
	                                      _react2.default.createElement("br", null),
	                                      "Hiking.  ",
	                                      _react2.default.createElement("br", null),
	                                      "  ",
	                                      _react2.default.createElement("br", null)
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement("div", { className: "r_text_Q" }),
	                                _react2.default.createElement("div", { className: "r_text_Q" })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "footer_sm_icon" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "headsocialLink" },
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: "",
	                                        style: { display: "block !important" }
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/SM_icon_01_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        style: { display: "block !important" },
	                                        href: "https://twitter.com/intent/tweet?url=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: ""
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/SM_icon_02_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        style: { display: "block !important" },
	                                        href: "https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: ""
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        style: {
	                                          display: "block !important",
	                                          width: "25px"
	                                        },
	                                        className: "forwardMail",
	                                        title: "Forward to email",
	                                        onClick: this.toggleMailShareForm
	                                      },
	                                      _react2.default.createElement("img", { src: _sendMailIcon2.default, alt: "" })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "back_event" },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/insights" },
	                                _react2.default.createElement(
	                                  "i",
	                                  { className: "fa fa-arrow-left" },
	                                  " ",
	                                  "browse Insights"
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(TeamModal, {
	              show: isShow,
	              onHide: this.togglePopUp,
	              activeItem: this.state.activeItem
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return SushmaKaushik;
	}(_react2.default.Component);
	
	SushmaKaushik.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SushmaKaushik;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-insights-sushma-kaushik-js-98dcfe9177b2168b1e25.js